import TicketsData from '../../components/tickets/ticketsData/TicketsData'
import { PageTitle } from '../../layout/core'

const CustomerSupport = () => {
  return (
    <div>
      <PageTitle breadcrumbs={[]}>Customer Support</PageTitle>
      <TicketsData />
    </div>
  )
}

export default CustomerSupport
